import React from 'react';
import {  Show,
ShowButton,List,EditButton,SimpleForm,
 Datagrid,RichTextInput,DisabledInput,TextInput,Edit,Create,
TextField, RichTextField ,SimpleShowLayout
 }
from 'admin-on-rest/lib/mui';

export const ZicuidateplansList = (props) => (
    <List title="רשימת תוכניות" {...props}>
        <Datagrid>
            <TextField label="#" source="id" />
             <TextField label="תוכנית" source="name" />
              <TextField  source="number_dates" />
    <TextField  source="default_dates" />
   <EditButton />
            <ShowButton />
        </Datagrid>
    </List>
);

const PostTitle = ({ record }) => {
    return <span> {record ? `${record.name}` : ''}</span>;
};


export const ZicuidateplansShow = (props) => (

<Show title={<PostTitle />} {...props}>
 <SimpleShowLayout>
   <TextField label="#" source="id" />
    <TextField label="תוכנית" source="name" />
     <TextField  source="number_dates" />
<TextField  source="default_dates" />

         </SimpleShowLayout>
    </Show>
);


export const ZicuidateplansEdit = (props) => (

<Edit title={<PostTitle />} {...props}>

        <SimpleForm>
    <DisabledInput label="#" source="id" />
     <TextInput label="תוכנית" source="name" />
      <TextInput  source="number_dates" />
   <TextInput  source="default_dates" />

        </SimpleForm>
  </Edit>
);


export const ZicuidateplansCreate = (props) => (
    <Create  {...props}>
      <SimpleForm >

        <DisabledInput label="#" source="id" />
         <TextInput label="תוכנית" source="name" />
          <TextInput  source="number_dates" />
       <TextInput  source="default_dates" />

      </SimpleForm>
    </Create>
);



// WEBPACK FOOTER //
// ./src/components/Zicuidateplans/zicuidateplan.js